import React from "react";
import { Autocomplete, AutocompleteProps } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

type ThemedAutocompleteProps<
  T,
  Multiple extends boolean = false,
  DisableClearable extends boolean = false,
  FreeSolo extends boolean = false
> = AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>;

function CustomAutocomplete<
  T,
  Multiple extends boolean = false,
  DisableClearable extends boolean = false,
  FreeSolo extends boolean = false
>(
  props: Readonly<
    ThemedAutocompleteProps<T, Multiple, DisableClearable, FreeSolo>
  >
) {
  return (
    <Autocomplete
      popupIcon={<KeyboardArrowDownIcon sx={{ color: "#AAA" }} />}
      className={props.limitTags ? "autocomplete-has-limit-tags" : ""}
      {...props}
    />
  );
}

export default CustomAutocomplete;
